/**
 * Turns queued unlocks into toasts.
 *
 * The achievements store records unlocks from anywhere, including code with no
 * React around it (the matchHistory store, the pack opening screen). It queues
 * the ids instead of announcing them, and this component, mounted once in the
 * app shell, drains the queue into the toast layer.
 *
 * Draining is a store action that clears as it reads, so mounting twice or
 * re-rendering cannot announce the same badge twice.
 */

import { useEffect } from 'react';
import { useAchievements } from '@/app/stores/achievements';
import { useToast } from '@/ui/system';
import { getAchievement } from './evaluator';
import { TIER_LABEL } from './types';

export function AchievementToasts() {
  const pending = useAchievements((s) => s.pending);
  const drainPending = useAchievements((s) => s.drainPending);
  const toast = useToast();

  useEffect(() => {
    if (pending.length === 0) return;
    const ids = drainPending();
    for (const id of ids) {
      const achievement = getAchievement(id);
      if (!achievement) continue;
      toast.push(
        `Achievement unlocked: ${achievement.name}`,
        'success',
        `${TIER_LABEL[achievement.tier]}. ${achievement.description}`,
      );
    }
  }, [pending, drainPending, toast]);

  return null;
}
